
if (!customElements.get('cosmedical-ingredient-collections')) {
  customElements.define('cosmedical-ingredient-collections', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const input = this.querySelector('[data-search-input]');
      if (!input) return;
      const controls = this.querySelector('[data-search-controls]');
      const clear = this.querySelector('[data-clear-search]');
      const reset = this.querySelector('[data-reset-search]');
      const count = this.querySelector('[data-result-count]');
      const empty = this.querySelector('[data-no-results]');
      const groups = [...this.querySelectorAll('[data-letter]')];
      const links = [...this.querySelectorAll('[data-letter-link]')];
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('en').replace(/[^a-z0-9]+/g, ' ').trim();
      const items = [...this.querySelectorAll('[data-ingredient-name]')].map(element => {
        const name = normalize(element.dataset.ingredientName);
        return { element, name, compactName: name.replaceAll(' ', '') };
      });
      const update = () => {
        const words = normalize(input.value).split(' ').filter(Boolean);
        let matches = 0;
        items.forEach(({ element, name, compactName }) => {
          const match = words.every(word => name.includes(word) || compactName.includes(word));
          element.hidden = !match;
          if (match) matches++;
        });
        const visibleLetters = new Set();
        groups.forEach(group => {
          group.hidden = ![...group.querySelectorAll('[data-ingredient-name]')].some(item => !item.hidden);
          if (!group.hidden) visibleLetters.add(group.dataset.letter);
        });
        links.forEach(link => {
          const enabled = visibleLetters.has(link.dataset.letterLink);
          if (enabled) { link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex'); }
          else { link.setAttribute('aria-disabled', 'true'); link.tabIndex = -1; }
        });
        // Translated texts come from the section (data-text-*), with [count] for the number.
        const key = (input.value.trim() ? 'textFound' : 'text') + (matches === 1 ? 'One' : 'Other');
        const fallback = `[count] ingredient ${matches === 1 ? 'entry' : 'entries'}${input.value.trim() ? ' found' : ''}`;
        count.textContent = (count.dataset[key] || fallback).replace('[count]', matches);
        clear.hidden = input.value.length === 0;
        empty.hidden = matches !== 0;
      };
      const clearSearch = () => { input.value = ''; update(); input.focus(); };
      input.addEventListener('input', update, { signal });
      input.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); clearSearch(); } }, { signal });
      clear.addEventListener('click', clearSearch, { signal });
      reset.addEventListener('click', clearSearch, { signal });
      links.forEach(link => link.addEventListener('click', event => { if (link.getAttribute('aria-disabled') === 'true') event.preventDefault(); }, { signal }));
      controls.hidden = false;
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
